import { render, staticRenderFns } from "./JoszakiPage.vue?vue&type=template&id=3594f0d4"
import script from "./JoszakiPage.vue?vue&type=script&lang=js"
export * from "./JoszakiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports